module.exports = __webpack_public_path__ + "img/f6-06.fa2e11e9.png";